"use strict";

exports.__esModule = true;
exports.default = void 0;
var _isObject = _interopRequireDefault(require("./isObject.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = function () {
  function object() {}
  return function (proto) {
    if (!(0, _isObject.default)(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();
var _default = exports.default = baseCreate;